const apiKey = 'eTUkErhizS_t7ZduvhGhKO9AHY8ktbqbOzK2fqld0OW65Q_MJznnqEdIHGQUvrM6ebyQmni-HRdL79LYZ4Bmr4jndmqvoYsF8mG0HGidPfaz5jJw41ugRouHUHYLW3Yx';

const Yelp = {
  search: function(term, location, sortBy) {
    return fetch(`https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}`, {
              headers: {Authorization: `Bearer ${apiKey}`}
            }).then(response => {
              return response.json();
            }).then(jsonResponse => {
              if(jsonResponse.businesses) {
                return jsonResponse.businesses.map(business => {
                  return {
                      id: business.id
                    , imageSrc: business.image_url
                    , name: business.name
                    , address: business.location.address1
                    , city: business.location.city
                    , state: business.location.state
                    , zipCode: business.location.zip_code
                    , category: business.categories[0].title
                    , rating: business.rating
                    , reviewCount: business.review_count
                  };
                });
              }
            });
  }
};

export default Yelp;



// WEBPACK FOOTER //
// ./src/util/Yelp.js